module.exports = __webpack_public_path__ + "static/media/kindergartenServicesBg.22fd753f.png";